'use client';

import { AlertContextProvider } from '@/context/Alert';
import AlertPopup from '@/components/AlertPopup';

export function Providers({ children }) {
  return (
    <AlertContextProvider>
      {children}
      <AlertPopup />
    </AlertContextProvider>
  );
}
